import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';
import { formatEther } from 'ethers/lib/utils';
import { useConfig } from '@app/config';

export function useDividentsStats() {
  const address = useAddress();
  const config = useConfig();
  const { contract } = useContract(config?.CONTRACTS.DIVIDENDS);
  const { contract: xKimContract } = useContract(config?.CONTRACTS.X_KIM);

  const { value, loading } = useAsync(async () => {
    if (!contract || !address || !xKimContract) {
      return;
    }

    const userAllocation = formatEther(
      await contract.call('usersAllocation', [address])
    );

    const totalAllocation = formatEther(await contract.call('totalAllocation'));

    const deallocationFee = await xKimContract.call('usagesDeallocationFee', [
      config?.CONTRACTS.DIVIDENDS
    ]);

    const dividendsShare = (+userAllocation * 100) / +totalAllocation;

    return {
      userAllocation,
      totalAllocation,
      dividendsShare,
      deallocationFee: deallocationFee / 100
    };
  }, [contract, address, xKimContract]);

  return {
    isLoading: loading,
    userAllocation: value?.userAllocation ?? 0,
    totalAllocation: value?.totalAllocation ?? 0,
    dividendsShare: value?.dividendsShare ?? 0,
    deallocationFee: value?.deallocationFee ?? 0
  };
}
